import { render } from "./AppInputRadio.vue?vue&type=template&id=c4bb8e02&scoped=true"
import script from "./AppInputRadio.vue?vue&type=script&lang=js"
export * from "./AppInputRadio.vue?vue&type=script&lang=js"

import "./AppInputRadio.vue?vue&type=style&index=0&id=c4bb8e02&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4bb8e02"]])

export default __exports__